import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { AddOrDeleteOrganizationPayload, AddOrganizationInput } from './generated/types';

const mutation = `mutation MyQuery($input: AddOrganizationInput!) {
    addOrganization(input: $input) {
        id
    }
}
`;

export const useAddOrganization = () => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (organizationToBeAdded: AddOrganizationInput) => {

            await (context.api.graphql({ query: mutation, variables: { input: organizationToBeAdded } }) as Promise<{
                data: {
                    addOrganization: AddOrDeleteOrganizationPayload;
                };
            }>);
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['listOrganizations'] }),
    },
    );
};